import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchBarContextService {

  textSearched = new BehaviorSubject<string>('');
  textSearched$ = this.textSearched.asObservable();

  constructor() {}

}
